/** Build the public MCP URL from the same API base used by the app. */
export function getMCPEndpoint(
  origin: string,
  apiBase = import.meta.env.VITE_API_URL || '/api/v1',
): string {
  const configured = apiBase.replace(/\/$/, '');
  const base = /^https?:\/\//.test(configured)
    ? configured
    : new URL(configured, origin).toString().replace(/\/$/, '');
  return `${base}/mcp`;
}
